import useSWR from 'swr'
import { chatRoomsApi } from '@/lib/api/client'

export function useConversationHistory(search?: string) {
  const { data, error, isLoading, mutate } = useSWR(
    ['conversation-history', search ?? ''],
    () => chatRoomsApi.getConversationHistory({ limit: 50, search: search || undefined }),
    { dedupingInterval: 5000, keepPreviousData: true },
  )

  return {
    entries: data?.items ?? [],
    total: data?.total ?? 0,
    isLoading,
    error,
    mutate,
  }
}
